import { useQuery } from '@tanstack/react-query'
import { fetchShopRegistryItems } from '.'

const SHOP_REGISTRY_REG_ITEMS_STATE_TIME = 0

/**
 * Helper that is used for building a shared react-query key.
 *
 * @param {number} registryId - Id of a registry.
 */
export const shopRegistryKey = (registryId) => ['shopRegistry', registryId]

/**
 * Hook that will fetch shop registry reg items.
 *
 * @param {number} registryId id of a registry.
 * @returns {object} All the things useQuery returns.
 */
export const useShopRegistryItems = (registryId) => {
  const query = useQuery({
    queryKey: shopRegistryKey(registryId),
    queryFn: () =>
      fetchShopRegistryItems(shopRegistryKey(registryId), registryId),
    staleTime: SHOP_REGISTRY_REG_ITEMS_STATE_TIME,
  })

  if (!query.data) return query

  return {
    ...query,
    data: query.data.sections,
  }
}
